// extracted by mini-css-extract-plugin
export default {"container":"webpack-pages-StudyList-StudyListItem-components-VotePanel-VoteContainer-module__container"};